import { storage } from "../storage/storage";
import MemoryCache from "../storage/memory-cache";

class StorageService {
    async exportDB() {
        return storage.exportRawBlob();
    }

    async importDB(blob) {
        await this.clearDB();
        return storage.importBlob(blob);
    }

    async clearDB() {
        MemoryCache.clearAll();
        return storage.clear();
    }
}

export default new StorageService();
